module.exports = __webpack_public_path__ + "img/m-icon-s-broke.602d05c5.png";